export const intentionHandleSubmit = (items) => {
  // Intention object
  const submitIntention = [];

  // Items should break out if anything is missing in even one column
  for (let i = 0; i < items.length; i++) {
    // Check if all the required fields are available - owner leaser not available so we removed the check on !items[i].owner || !items[i].leaser ||
    if (
      !items[i].district ||
      !items[i].district_id ||
      !items[i].year ||
      !items[i].loosing_crop ||
      !items[i].loosing_amount ||
      !items[i].gaining_crop ||
      !items[i].gaining_amount
    ) {
      return { message: "Missing items." };
    }
  }

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    // Compile fields so that items that are not needed
    const intention = {
      district: String(item.district).trim(),
      district_id: (item.district_id).trim(),
      year: String(item.year),
    };
    console.log(parseFloat(item.leaser).toFixed(2));

    if (item.owner) {
      intention.owner = parseFloat(item.owner).toFixed(2);
    }

    if (item.leaser) {
      intention.leaser = parseFloat(item.leaser).toFixed(2);
    }

    // Loosing crop
    const loosing_crop_array = item.loosing_crop.split(",");
    const loosing_amount_array = item.loosing_amount.split(",");

    // Gaining crop
    const gaining_crop_array = item.gaining_crop.split(",");
    const gaining_amount_array = item.gaining_amount.split(",");

    // Check if they are equal length so that each item has its corresponding amount and crop
    if (
      loosing_amount_array.length !== loosing_crop_array.length ||
      gaining_amount_array.length !== gaining_crop_array.length
    ) {
      return { message: "Gaining/loosing crop and amount should be equal." };
    }

    // Loosing array
    const loosing = [];
    for (let j = 0; j < loosing_crop_array.length; j++) {
      loosing.push({
        amount: parseFloat(loosing_amount_array[j]),
        crop: String(loosing_crop_array[j]).trim(),
      });
    }

    // Gaining array
    const gaining = [];
    for (let j = 0; j < gaining_crop_array.length; j++) {
      gaining.push({
        amount: parseFloat(gaining_amount_array[j]),
        crop: String(gaining_crop_array[j]).trim(),
      });
    }

    // Append the gaining and loosing to the object
    intention.loosing = loosing;
    intention.gaining = gaining;

    // Push the data into the array of objects
    submitIntention.push(intention);
  }

  // Submit the data
  return submitIntention;
};
